import Vue from "vue";
import Vuex from "vuex";
// userInfo
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    speakerDevice: null,
    audioDevice: null,
  },
  mutations: {
    setSpeakerDevice(state, deviceId) {
      state.speakerDevice = deviceId;
    },
    setAudioDevice(state, deviceId) {
      state.audioDevice = deviceId;
    },
  },
  actions: {
  }
});
export default store;
